export default "__VITE_ASSET__BJXBxCzP__"